export const ItemTypes = {
  CARD: `card`,
  CONTACT: `contact`,
  FORM_QUESTION: `form-question`,
  PACKET_FORM: `packet-form`,
}
